/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});

function setBlogMenu() {
  if($(".parent-blog").length > 0) {
    var maxH = 0;
    var hInterval = setInterval(function(){
      //console.log($(".parent-blog .mega_title").height());
      if($(".parent-blog .mega_title").height() > 10 ) {
        $(".parent-blog .mega_title").css({"height": "auto"});
        $(".parent-blog .mega_title").each(function(){
          if($(this).height() > maxH) {
            maxH = $(this).height();
          }
        });
        if(maxH > 0) {
        	$(".parent-blog .mega_title").css({"height": maxH+"px"});
          clearInterval(hInterval);
        }
        else {
          //$(".parent-blog .mega_title").css({"height": "auto"});
          setBlogMenu();
        }
        
      }
    }, 300);
        
    
    var maxH1 = 0;
    var hInterval1 = setInterval(function(){
      if($(".parent-blog .mega_txt p").height() > 10 ) {
        $(".parent-blog .mega_txt p").css({"height": "auto"});
        $(".parent-blog .mega_txt").each(function(){
          if($(this).children("p").height() > maxH1) {
            maxH1 = $(this).children("p").height();
          }
        });
        if(maxH1 > 0) {
        	$(".parent-blog .mega_txt p").css({"height": maxH1+"px"});
          clearInterval(hInterval1);
        }
        else {
          //$(".parent-blog .mega_txt").css({"height": "auto"});
          setBlogMenu();
        }
        
      }
    }, 300);
    
    
  }
}

function setVariantImage(variantID) {
  var variantData = $("#variant-json").html();
  variantData = JSON.parse(variantData);
  $.each(variantData, function (i, obj) {
    if(obj.id == variantID) {
      var featured_id = obj.featured_media.id;
      console.log(featured_id);
      var slick_index = $(".product_slider_first [data-media-id='"+featured_id+"']").data("slick-index");
      $(".product_slider_first").slick('slickGoTo', slick_index);      
    }
  });
}

$(document).on("change", "variant-selects select.select__select", function(){
  var variantID = $(".product-form input[name='id']").val();
  console.log(variantID);
  setVariantImage(variantID);
});




$(function() {
  setBlogMenu();
  /*if($('.product_slider_first').length > 0) {
    $('.product_slider_first').slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      speed: 800,
      //asNavFor: '.product_slider.grid_slide'
    });
    
    $('.product_slider.grid_slide').slick({
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 1,
      focusOnSelect: true,
      arrows: false,
      infinite: true,
      centerMode: true
      
    });  
  }
  
  $('.product_slider.grid_slide').on('click', '.slick-slide', function (e) {
    var $currTarget = $(e.currentTarget), 
        index = $currTarget.data('slick-index'),
        slickObj = $('.product_slider_first').slick('getSlick');

    slickObj.slickGoTo(index);
  });*/
  
  
  if($('.bundle-slider').length > 0) {
    $('.bundle-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1030,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          
          } 
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            arrows: true,
            slidesToScroll: 1
          
          } 
        }
     ]                         
    });
  }

  if (navigator.userAgent.indexOf('Mac OS X') != -1) {
    $("body").addClass("mac");
  } else {
    $("body").addClass("windows");
  }
  if($(".quantity-bag-wrapper").length > 0) {
    let checkForBundle = setInterval(function() {
      if($(".quantity-bag-wrapper .bold_bundles_product_loaded .bold-bundles-child-product-info").length > 0) {
        $("body").addClass("bundle-page");
        if($(window).width() <= 768) {
          if($(".quantity-bag-wrapper .wishlist_sec").length > 0) {
            $(".quantity-bag-wrapper .wishlist_sec").appendTo("product-form.product-form");
          }
          else {
            $("product-form.product-form .wishlist_sec").appendTo(".quantity-bag-wrapper");
          }
        }
        clearInterval(checkForBundle);
      }
    }, 500);
  }
  if($("body").hasClass("collection")) {
    //fillEmptyGrid();
  }

  function fillEmptyGrid() {
    let gridLength = $(".product-grid >li").length;
    if(gridLength % 4 > 0) {
      let emptyGrid = (4 - (gridLength % 4) - 1);
      console.log("Empty cell: "+emptyGrid);
      let pageUrl = $(".pagination__list > li:last-child").children("a").attr("href");
      $.ajax({
         method: 'GET',
         url: pageUrl,
         success: function(data){
           $(data).find("#product-grid >li").each(function(index){
               if(index <= emptyGrid) {
                  //console.log($(this));
                 $("#product-grid").append($(this));
               }
           });
         },
          error: function (jqXHR, exception) {
             console.log("Status: " + jqXHR.status + "Response: " + jqXHR.responseText);
          }
       });
    }
  }
});


$(window).on("load resize", function(){
          setBlogMenu();
   if($(window).width() < 768){ 
      $(".header__search").prependTo(".menu-drawer__navigation-container");
      $(".okeReviews-reviewsAggregate-summary").insertAfter(".okeReviews-reviews-main .review-image-wrapper");
   }
});

/*
$(window).on("load resize", function(){
          setBlogMenu();
  if($(window).width() < 768){
    $(".product__info-container .product__text").appendTo(".mobile_product_title");
    $(".product__info-container .price_title_wrapper").appendTo(".mobile_product_title");
    $(".product__info-container .variant-selector").insertAfter(".after_pay");
    $(".quantity-bag-wrapper .add-to-cart-wrapper").insertAfter(".quantity-bag-wrapper");
    $(".product__info-container .okendo-with-title").insertAfter(".price_title_wrapper");
    $(".variant-selector").insertBefore(".quantity-bag-wrapper");
  }
  else{
    $(".mobile_product_title").prependTo(".product__info-container");
    $(".mobile_product_title").insertAfter(".product__text.subtitle");
  }
  
});
*/







$(document).ready(function(){
  $(".bundles-grid").mouseenter(function(){
   	$(this).children(".bundle-img").children().children(".add-cart").addClass("active");
    $(this).children(".bundle-img").children(".okendo-app").addClass("active");
  });
  $(".bundles-grid").mouseleave(function(){
   	$(this).children(".bundle-img").children().children(".add-cart").removeClass("active");
    $(this).children(".bundle-img").children(".okendo-app").removeClass("active");
  });

  if($(window).width() <= 768) {
    setTimeout(function(){
     let btn_append = setInterval(function(){
       if($(".klaviyo-form-KVVxvJ").length > 0) {
            $(".btn-signp").appendTo(".klaviyo-form-KVVxvJ > div");
       }
       console.log("btnappend");
       clearInterval(btn_append);
       
      }, 1000);
      }, 3000);
  }
 
if($(".quantity-bag-wrapper .zooomypwishmsg i.fa.fa-heart").length>0)
     {
       $(".remove_wishlist").show();
     }
     else{
       $(".remove_wishlist").hide();
     }
  
  $('body').on('click', '.custom_pdp .quantity-bag-wrapper .wishlist_sec .zooomypwishmsg i.fa.fa-heart-o', function() {    
   $(".remove_wishlist").show();
    $(".added_wishlist").show();
  setTimeout(function(){
    $(".added_wishlist").hide();
  }, 200)
    
    });


   $('body').on('click', '.custom_pdp .quantity-bag-wrapper .wishlist_sec .zooomypwishmsg i.fa.fa-heart', function() {
    $(".remove_wishlist").hide();
     if($(".wishlist_sec .zooomypwishmsg i.fa.fa-heart-o"))
     {
       $(".remove_wishlist").hide();
     }
     else{
       $(".remove_wishlist").show();
     }
   });
     
    $('.js-okeReviews-showMore').on('click', function() {
        setTimeout(function() {
    $(".okeReviews-reviews-main > .okeReviews-reviews-review").each(function() {
        $(this).find(".okeReviews-review-reviewer-profile-details").prependTo($(this).find(".okeReviews-review-primary"));
    });
         $(".okeReviews-reviews-main > .okeReviews-reviews-review").appendTo(".okeReviews-reviews-review-wrapper");
          console.log('readmoreclicked');
        }, 2000);
    });

  
});



/******************* 22 dec color swatches  ************/
$(function(){
  
if($(".pop-up-cart-btn").attr("data-id") != ""){
    $(this).addClass("active");
  }
 
$('.selector-wrapper .single-option-selector').on('change', function() {
  if($(this).val() != "Select a Variant"){
    $(this).parent().next().removeClass("disabled");
  }
  else{
    $(this).parent().next().addClass("disabled");
  }
   
  var variant = "";
  var select_length = $(this).parent().children(".single-option-selector").length - 1;
  
  
  $(this).parent().children(".single-option-selector").each(function(index){
		
    if (index == select_length){
      
      variant += $(this).val();
    }
    else{
      variant += $(this).val() + " / ";
    }

  });

	var var_id;
  
  $(this).parent().next().next(".ul-hide").children("li").each(function(){
  
    
    if($(this).attr("data-name") == variant){
      var_id = $(this).attr("data-id");
    }
 
  });

  $(this).parent().next(".pop-up-cart-btn").attr("data-id", var_id);
   
});
  
  
  
  $("body").on("click", ".pdp-accordion .acc-head", function(){
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });  
  

  
});

function collectionHover() {
  $(".card-wrapper").mouseenter(function(){
   	$(this).children(".card--product").children(".card_review").addClass("active");
    $(this).children(".card--product").children().children(".add-cart").addClass("active");
  });
  $(".card-wrapper").mouseleave(function(){
   	$(this).children(".card--product").children(".card_review").removeClass("active");
    $(this).children(".card--product").children().children(".add-cart").removeClass("active");
  });
}

/*$("body").on("click", ".facets__list list .list-menu__item label", function(){
  console.log('clickeddd');
   setTimeout(function () {
  collectionHover();
   }, 2000);
});*/  


/*Okendo Review*/


$(window).on("load", function() {

  if($('.myslider').length > 0) {
    $('.myslider').slick({
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
      responsive: [
        {
          breakpoint: 1030,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          
          } 
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          
          }
        },
         {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          
          }
        },
     ]

  });
  }

  if($('.expert-slider').length > 0) {
    $('.expert-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
    });
  }
  
    /*$('.product_slider_first .slide-item').each(function(){
       $(this).find('img').on("click", function(){
          var img_src = $(this).attr('src');
          $(".image-popup img").attr("src", img_src);
          $(".image-popup").addClass("active");
          $("body").addClass("overflow");
        });
	});
    $(".image-popup .close-button").on("click", function(){
      $(".image-popup").removeClass("active");
      $("body").removeClass("overflow");
    });*/
  
if ($(window).width() > 767) {
      if($(".magnifyZoom").length > 0) {
      	$('.magnifyZoom').magnify({
          afterLoad: function() {
            console.log('Magnification powers activated!');
          }
        });
      }
}
   
      
      if($('.custom-contact').length > 0) {
      	$('body').addClass('contact-page');
      }     
  
 setTimeout(function () {
   
    $('#shopify-block-f946f06b-3dc4-4936-bd27-4e2f7a7d06d1 .okeReviews-reviewsCarousel-review-reviewer .okeReviews-reviewsCarousel-review-reviewer-name').each(function(){
	   $(this).prependTo($(this).parent().prev()); 
	});
   
    $('#shopify-block-f946f06b-3dc4-4936-bd27-4e2f7a7d06d1 .okeReviews-reviewsCarousel-slider-slide-inner .okeReviews-reviewsCarousel-review-content .okeReviews-reviewsCarousel-review-content-heading').each(function(){
	   $(this).prependTo($(this).prev()); 
	});
   
   var head_text = $("#shopify-block-f946f06b-3dc4-4936-bd27-4e2f7a7d06d1 .okeReviews-reviewsCarousel-heading").html();
       
   $("#shopify-block-f946f06b-3dc4-4936-bd27-4e2f7a7d06d1 .okeReviews-reviewsCarousel-slider").prepend("<div class='section-head'>"+ head_text +"</div>");

 
   /*radmore btn*/
   
/*  var max = 150;
    $(".okeReviews-reviewsCarousel-review-content-body").each(function() {
        var str = $(this).text();
        if ($.trim(str).length > max) {
            var subStr = str.substring(0, max);
            var hiddenStr = str.substring(max, $.trim(str).length);
            $(this).empty().html(subStr);
            $(this).append('<span class="read-dots">... </span><a href="javascript:void(0);" class="btn-link">Read more</a>');
            $(this).append('<span class="addText">' + hiddenStr + '</span>');
        }
    });

    $(".btn-link").click(function() {
        $(this).siblings(".addText").contents().unwrap();
        $(this).remove();
        $(".read-dots").hide();
        
    });*/
   
   
       $(".okeReviews-reviewsCarousel-review-content-body").each(function() {
     
            $(this).append('<a href="javascript:void(0);" class="btn-link">Read more</a>');
            
        
    });
   
   
   
   
 }, 3000);
      
/*    
setTimeout(function () {  
    if($('#insta-feed').length > 0) {
    $('#insta-feed > div').slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 4,
      speed: 800,
      slidesToScroll: 1,
      adaptiveHeight: true,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          
          } 
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          
          } 
        }
     ]                         
    });
  }
  }, 2000);  

  */




 $('.partner_logo_inner ul').slick({
    dots: false, 
      arrows: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
   	  speed: 800,
      autoplay: true,

    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],

  });
      
});




/*PDO custom variant dropdown*/
$('body').on('click', '.select-box', function() {
    $(this).next('.custom-variant-list').toggleClass('active');
});


$('body').on('click', '.custom-variant-list li', function() {
  
   var attr_value = $(this).attr('data-value');
  	$(this).parent().prev().text(attr_value);
    $(this).parent().removeClass('active');
   
/*  	$(this).parent('.custom-variant-list').toggleClass('active');
    var selectID = $(this).parent().attr('data-id');
    console.log(selectID);
      $('#'+selectID).val(attr_value);
      var elem = document.getElementById(selectID);
      elem.dispatchEvent(new Event("change"));
	$(this).parent().prev().children("em").css("display","none");*/
  
});

/*$(document).click( function(event){
    if ( !$(event.target).closest('.select-box').length ) {
         $(".custom-variant-list").removeClass("active");
    }
});*/



/*Okendo Review end*/

/*OS class*/
  if (navigator.userAgent.indexOf('Mac OS X') != -1) {
  $("body").addClass("mac");
} else {
  $("body").addClass("windows");
}







$(window).on("load", function() {

 setTimeout(function () {
   
    $('#ZoomyWishlistPage .ZoomyWishlistPageGrid').each(function(){
	   $(this).children('.zprice').appendTo($(this).children('.zbodytitle')); 
	});
   
 }, 2000);

  $(".info-wrap .product-type").insertAfter(".price_title_wrapper");
  $(".product-tags").insertAfter(".info-wrap .product-type");
});




/************ customer page	***************/


$(window).on("load", function() {
/*$(".customer.addresses button[aria-expanded='false']").click(function(){
	$(this).attr("aria-expanded","true")
});*/

  
 
  /*$('.customer.addresses button.address__cancel').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).addClass('address_hide');
    });
	$('.customer.addresses button.address-edit').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).removeClass('address_hide');
    });
  
  
  $('.customer.addresses button.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });*/

   setInterval(function () {
    $('.search').attr('action','/search');
    $('#isp_mobile_dropdown_form').attr('action','/search');
   }, 1000);
  
    /*$('.search ul.grid li').filter(function() {
      return $(this).text().trim().length == 0;
    }).remove();*/
  
});




/****** testimonials	*************/


  


$(function() {
  if($('.experts_slider-container').length > 0) {
    $('.experts_slider-container').slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true
    });
  }
  
});





/****************** header fixed ----------*/
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 5) {
        $("#shopify-section-header").addClass("fixed_header");
      $("#shopify-section-mini-cart").addClass("announcement");
    }
    else{
        $("#shopify-section-header").removeClass("fixed_header");
      $("#shopify-section-mini-cart").removeClass("announcement");
    }
}); 




/*Footer*/

$(document).ready(function(){

  $(".last-grid.grid_5").appendTo(".footer__blocks-wrapper .grid__item.grid_4");
  $('.grid__item.grid_4').children().wrapAll("<div class='grid_4_wrapper'></div>");

      // bind change event to select
      $('#custom-variant').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });
      $('#custom-variant .selected-op').prependTo('#custom-variant');

    $('#custom-variant').not(':has(option)').addClass('none');
    $('#custom-variant').not(':has(option)').parent().parent().addClass('none');


/*Okendo review pdp redesign*/
  /*
if($('.okeReviews-widget-holder').length > 0) {
  $(".okeReviews-widget-holder > .okeReviews").prepend("<div class='new-heading'><h2>");
   setTimeout(function () {
    var pTitle = $(".product__title").html();
    var percent = $('.okeReviews-reviewsAggregate-recommends > span').html();
    $(".new-heading h2").html(percent + " of X50 Customers recommend" + pTitle + "to their friends");
   }, 2000);
}  
*/
  
if ($(window).width() < 768) {
   $("#FacetFiltersFormMobile details").each(function(){
    var $list = $(this).find(".mobile-facets__list");
    $list.children().detach().sort(function(a, b) {
      return $(a).text().localeCompare($(b).text());
    }).appendTo($list);
  });
}
else {
   $("#FacetsWrapperDesktop details").each(function(){
    var $list = $(this).find(".facets__list");
    $list.children().detach().sort(function(a, b) {
      return $(a).text().localeCompare($(b).text());
    }).appendTo($list);
  });
}  

});


$(window).on("load", function(){
  setTimeout(function () {
    console.log('slider start')
    $('#insta-feed > div').slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 4,
      speed: 800,
      slidesToScroll: 1,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          
          } 
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          
          } 
        }
     ]                         
    });
}, 6000);
});



if ($(window).width() < 768) {
$(document).on('click', '.product_slider_first li img', function() {
  var attr_value = $(this).attr('data-media-id');
  //console.log(attr_value);
  $('.product .product-media-modal.media-modal').attr('open', '');
  
  $('.product-media-modal__content img').each(function(){
    	var img_attr = $(this).attr('data-media-id');
    
        if(attr_value == img_attr){
          $('.product-media-modal__content img').removeClass('active');
          $(this).addClass('active');
        }
    
  });
  
});

}


    
$(document).ready(function() {
    $(".slide-item .product__modal-opener img").on("click", function() {
      var srcset = $(this).attr("srcset");
      var sources = srcset.split(',');
      var url = sources[0].trim().split(' ')[0];
      $(".switch-image").attr("src", url);
      $('.switch-image').css('display', 'block');
      $('.switch-video').css('display', 'none');

      var video = $('.switch-video')[0]; // Get the first video element
      if (video) {
        video.pause();
      }
    });

if($(".variant-selector").length > 0) {
   $('.variant-selector, .product-form__quantity').wrapAll('<div class="product-info-wrapper"></div>');
    var sizeElement = $('.form__label:contains("Size")').parent().parent();
    var flavourElement = $('.form__label:contains("Flavours")').parent();
    //var sizeElement = $('.variant-selector .product-form__input')[0].parent();
    //var flavourElement = $('.variant-selector .product-form__input')[1].parent(); 
  
    sizeElement.detach();
    flavourElement.detach();

    $('.product-info-wrapper').prepend(sizeElement);
    $('.product-info-wrapper').append(flavourElement);  
    //var firstChildDiv = $(".product-info-wrapper").find("div").first();
    //$(".product-info-wrapper").append(firstChildDiv);
}else{
  $('.quantity-bag-wrapper').addClass('noVariants');
  //$('.product-form__quantity').wrapAll('<div class="product-info-wrapper"></div>');
  //$(".product-info-wrapper").insertBefore(".quantity-bag-wrapper");
  //$(".product-info-wrapper").append(firstChildDiv);
}
  
setTimeout(function() {
$(".okeReviews-reviewsAggregate-summary").insertBefore(".okeReviews-reviews-main");
$(".okeReviews-reviews-main .okeReviews-reviews-review").wrapAll('<div class="okeReviews-reviews-review-wrapper"></div>');
$(".okeReviews-reviews-main .okeReviews-reviews-review").each(function() {
    $(this).find(".okeReviews-review-reviewer-profile-details").prependTo($(this).find(".okeReviews-review-primary"));
});

//var img_src = $(".okeReviews-reviews-review-wrapper").first('.okeReviews-reviews-review').find('img').attr('data-oke-reviews-lazy-image-url');
var newSrc = $('.okendo-with-title').attr('data-src');  
var newDiv = `
  <div class='review-image-wrapper'>
    <img src="${newSrc}" alt='product-image'/>
  </div>
`;

$(".okeReviews-reviews-main").prepend(newDiv);
$(".okeReviews-reviewsAggregate-summary .okeReviews-reviewsAggregate-summary-total").appendTo(".okeReviews-reviewsAggregate-summary .okeReviews-reviewsAggregate-summary-rating");
}, 2000);

/*  if ($('body').hasClass('product')) {
     const $button = $('.js-okeReviews-showMore');
     $button.text('Read more reviews');
     $(".okeReviews-reviews-footer").prependTo(".okeReviews-reviews-review-wrapper");
  }*/

if ($('body').hasClass('product')) {
    const $button = $('.js-okeReviews-showMore');
        $button.text('Read more reviews');
    let rc_interval = setInterval(function(){
      if($(".onetime-radio").length > 0) {
        let label_text = $(".onetime-radio .rc-radio__label").text().split("$");
        let label_splitText = `<span>${label_text[0]}</span><span class="rc-radio__price">$${label_text[1]}</span>`;
        $(".onetime-radio .rc-radio__label").html(label_splitText);
        clearInterval(rc_interval);
      }
    if ($('.is-okeReviews-empty').length > 0) {
      $('.is-okeReviews-empty').parent().parent().addClass('empty-review');
    }  
    }, 1000); 
  }

if ($('body').hasClass('bundle-page')) {
    $('.product-info-wrapper .product-form__quantity').prependTo('.quantity-bag-wrapper'); 
}
  
});


/*$(document).ready(function() {
  $('.deferred-media').on('click', function() {
    var videoSrc = $(this).find('video').attr('src');
    $('.switch-video source').attr('src', videoSrc);
    
    $('.switch-video')[0].load();
    $('.switch-image').css('display', 'none');
    $('.switch-video').css('display', 'block');
  });
});*/


$(document).ready(function() {
    // Attach click event listener to deferred-media
    $('.deferred-media').on('click', function() {
      // Find the child 'template video'
      var templateVideo = $(this).find('video');

      // Get source and poster URLs from the 'template video'
      var videoSource = templateVideo.find('source').attr('src');
      var imageSource = templateVideo.find('img').attr('src');

      var videoPlayer = `<video class="switch-video" controls autoplay="autoplay" preload="none" poster="${imageSource}">
        <source src="${videoSource}" type="video/mp4"><img src="${imageSource}"></video>`

            $('#video-container').html(videoPlayer);

      // Show the updated video
    $('.switch-image').css('display', 'none');
    $('#video-container').css('display', 'block');
    });
  });



$(document).ready(function () {
    // Get the initial variant data from the script tag
    var variants = JSON.parse($('#variant-json').html());

    function updateProductImage(selectedVariant) {
      var matchingVariant = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedVariant[index];
        });
      });

      if (matchingVariant && matchingVariant.featured_media) {
        var newImageUrl = matchingVariant.featured_media.preview_image.src;
        $('.product__media img').attr('src', newImageUrl);
        
        var mediaImageUrl = $('.product__media img').attr('src');
        
        if (newImageUrl === mediaImageUrl) {
          console.log('matched'+ mediaImageUrl);
          
          $(".switch-image").attr("src", mediaImageUrl);
        }
      }
    }

    $('.select__select').on('change', function () {
      var selectedVariant = [];
      $('.select__select').each(function () {
        selectedVariant.push($(this).val());
      });

      updateProductImage(selectedVariant);
    });

    //updateProductImage(variants[0].options);
  });
